/* Generated file */

export enum Nature {
	Appartement = "Appartement",
	Maison = "Maison",
	NonPrecise = "NonPrecise",
}
